import cx from 'classnames'

import classes from '../styles.module.scss'

type Props = {
  title: string
  text: string
}

export default function VerificationInProgress({ title, text }: Props) {
  return (
    <div className={classes.root}>
      <h4 className={classes.title}>
        <b>{title}</b>
      </h4>
      <p className={cx('text-smaller', classes.textVerified)}>
        <img
          className={classes.iconProcess}
          src={`${process.env.IMG_ORIGIN}/icons/in-process.svg`}
          alt='process-icon'
        />
        {text}
      </p>
    </div>
  )
}
